import axios from "axios"

type SearchAddressResponse = {
    inline_name: string
    citycode: string
    street: string
    zipcode: string
    city: string
}

export class AddressService {
    /**
     * Recherche des adresses par recherche textuelle
     * @param text - Texte de recherche
     * @returns - Liste des adresses trouvées
     */
    async searchAddress(
        text: string,
        limit: number = 20
    ): Promise<SearchAddressResponse[]> {
        try {
            const { data } = await axios.get("/api/gouv/search", {
                params: {
                    q: text,
                    limit,
                },
            })
            return data.features?.map(
                (feature: {
                    properties: {
                        label: string
                        citycode: string
                        name: string
                        postcode: string
                        city: string
                    }
                }) => {
                    return {
                        inline_name: feature?.properties?.label,
                        citycode: feature?.properties?.citycode,
                        street: feature?.properties?.name,
                        zipcode: feature?.properties?.postcode,
                        city: feature?.properties?.city,
                    }
                }
            )
        } catch (e: any) {
            throw new Error(
                e.response.data?.message ||
                    "Erreur lors de la recherche d'adresse"
            )
        }
    }
}

export type { SearchAddressResponse }
